import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Product } from '../types';
import { useOrg, useTryonStatus } from '../context/OrgContext';
import { siteTitle } from '../utils/config';
import { loadTryonCatalogue } from '../lib/tryon/catalogue';
import LiveTryonStage from '../components/tryon/LiveTryonStage';

const TryonPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requestedId = searchParams.get('productId');
  const org = useOrg();
  const tryonStatus = useTryonStatus();

  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  // Set page title
  useEffect(() => {
    document.title = `Virtual Try-On - ${siteTitle(org?.org_name)}`;
    return () => { document.title = siteTitle(org?.org_name); };
  }, [org]);

  // Load catalogue frames
  useEffect(() => {
    if (tryonStatus !== 'enabled') return;
    let cancelled = false;
    loadTryonCatalogue().then((frames) => {
      if (cancelled) return;
      setProducts(frames);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, [tryonStatus]);

  const target = requestedId
    ? products.find((p) => String(p.id) === requestedId) ?? null
    : null;

  if (tryonStatus === 'loading') {
    return (
      <div className="tryon-page" style={{ maxWidth: '1400px', margin: '0 auto', padding: '16px var(--page-pad)' }}>
        <div
          className="tryon-page__stage-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '700px',
            background: '#000',
            color: '#fff',
            borderRadius: '16px'
          }}
        >
          <div>Loading Engine...</div>
        </div>
      </div>
    );
  }

  if (tryonStatus === 'disabled') {
    return (
      <div className="empty-state" style={{ minHeight: '60vh' }}>
        <h2>Virtual Try-On is not available</h2>
        <p>This feature is currently disabled for this store.</p>
        <button className="btn btn--primary" onClick={() => navigate('/products')}>Browse Products</button>
      </div>
    );
  }

  return (
    <div className="tryon-page" style={{ maxWidth: '1400px', margin: '0 auto', padding: '16px var(--page-pad)' }}>
      <div className="tryon-page__stage-container" style={{ height: '750px', background: '#000', borderRadius: '16px', overflow: 'hidden', position: 'relative' }}>
        <LiveTryonStage
          products={products}
          loadingProducts={loading}
          targetProduct={target}
          onViewDetails={(p) => navigate(`/product/${p.id}`)}
        />
      </div>
    </div>
  );
};

export default TryonPage;
